import { Input, ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractBasketComponent } from '@df/basket/abstract-basket.component';

@Component({
    selector: 'basket-view-submit',
    templateUrl: 'basket-view-submit.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketViewSubmitComponent extends AbstractBasketComponent {
    @Input()
    redirectPath: string = '/checkout';
}
